module.exports = __webpack_public_path__ + "img/7.29b4c844.jpg";